"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Mutation", {
  enumerable: true,
  get: function get() {
    return _Mutation.default;
  }
});
Object.defineProperty(exports, "Query", {
  enumerable: true,
  get: function get() {
    return _Query.default;
  }
});
Object.defineProperty(exports, "createBrowserApolloClient", {
  enumerable: true,
  get: function get() {
    return _browser.default;
  }
});
Object.defineProperty(exports, "createServerApolloClient", {
  enumerable: true,
  get: function get() {
    return _server.default;
  }
});
var _server = _interopRequireDefault(require("./server"));
var _browser = _interopRequireDefault(require("./browser"));
var _Query = _interopRequireDefault(require("./Query"));
var _Mutation = _interopRequireDefault(require("./Mutation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//# sourceMappingURL=index.js.map